const prodDefault = 'https://api.lartbanne.com/';
const betaDefault = 'https://beta-api.lartbanne.com/';

const defaultBase =
    String(process.env.REACT_APP_PRODUCTION) === 'true' ? prodDefault : betaDefault;

const IMG_BASE =
    (process.env.REACT_APP_IMG_URL || defaultBase).replace(/\/+$/, '') + "/uploads/artbanne";

export function toImg(src?: string): string {
    if (!src) return '';
    if (/^https?:\/\//i.test(src)) return src; // already absolute
    return `${IMG_BASE}/${src.replace(/^\/+/, '')}`;
}